<div class="striped-bg"></div>
<div class="search-header">
  <h2>Latest Posts</h2>
  <p>What you're about to witness is my thoughts (just my thoughts, man) — right or wrong, just what I was feeling at the time. 🙏💎</p>
</div>
<div class="search-filter">
  <form class="search striped-bg">
    <input type="text" placeholder="Search posts" [value]="searchTerm.value" (input)="searchEntries($event)" />
    <button class="button primary search-clear" type="reset" (click)="searchEntries($event)" [disabled]="!searchTerm.value.length">
      <img src="../../../assets/images/close-yellow-001.svg" width="30" alt="Blog Home Search Clear">
    </button>
  </form>
  <form class="filter" (appClick)="closeFilter($event)">
    <label class="filter-by" (click)="closeFilter($event)">Filter by:</label>
    <button class="dropdown" type="button" [attr.data-content]="'Blog Home Filter Category'" (click)="openFilter('categories', $event)">
      Category
      <img src="../../../assets/images/down-arrow-gold-001.svg" width="20" alt="Down Arrow" />
    </button>
    <button class="dropdown" type="button" [attr.data-content]="'Blog Home Filter Tag'" (click)="openFilter('tags', $event)">
      Tag
      <img src="../../../assets/images/down-arrow-gold-001.svg" width="20" alt="Down Arrow" />
    </button>
    <button class="button" type="reset" [attr.data-content]="'Blog Home Filter Reset All'" (click)="resetAllFilters($event)" [disabled]="!isResetAllBtnActive">
      Reset All
      <img src="../../../assets/images/close-gold-001.svg" height="14" alt="Close Icon" />
    </button>
    <div class="filter-menu" *ngIf="isFilterOpen" [style]="'left: ' + (menuPosLeft || 0) + 'px'" (keydown.escape)="closeFilter()"> 
      <div class="fm-container">
        <form class="fm-search">
          <input type="search" [placeholder]="'Search ' + (menuOptions[0].type === 'tags' ? 'Tags' : 'Categories')" [(ngModel)]="filterSearch" (input)="trackSearch($event)" />
          <button class="primary search-clear" type="reset" [disabled]="!filterSearch.length" [attr.data-content]="'Blog Home Filter Search Clear, ' + menuOptions[0].type" (click)="filterSearch = ''; analyticsService.trackInput($event)">
            <img src="../../../assets/images/close-yellow-001.svg" width="20" alt="Close Icon">
          </button>
        </form>
        <ul class="options"> 
          <li *ngFor="let opt of filteredMenuOpts; let i = index">   
            <input 
              type="checkbox" 
              [(ngModel)]="opt.data.selected" 
              [class]="isActiveCrit(menuOptions[0].type, opt.data.name) ? 'active' : ''" 
              [name]="'filter_' + opt.data.name" 
              [attr.data-content]="'Blog Home Filter Option, ' + menuOptions[0].type + ', ' + opt.data.name + ', ' + !opt.data.selected" 
              (ngModelChange)="btnActive()" 
              (change)="analyticsService.trackInput($event)" 
            /> 
            <label [for]="'filter_' + opt.data.name">
              {{opt.data.name}} 
              <small *ngIf="opt.data.count">[{{opt.data.count}}]</small>
            </label> 
          </li> 
        </ul> 
        <div class="actions">
          <button class="button" type="button" (click)="FilterEntries(menuOptions[0].type, $event)" [disabled]="!isApplyBtnActive" [attr.data-content]="'Blog Home Filter Apply, ' + menuOptions[0].type">Apply</button>
          <button class="button" type="reset" [disabled]="!isResetBtnActive" [attr.data-content]="'Blog Home Filter Reset, ' + menuOptions[0].type" (click)="btnActive($event)">
            <img src="../../../assets/images/close-gold-001.svg" width="20" alt="Close Icon" />
          </button>
        </div> 
      </div>
    </div>
  </form>
</div>
<div class="search-footer">
  <div *ngIf="filterCriteria.value.length" class="selections">
    <div *ngFor="let f of filterCriteria.value">
      <strong>Selected {{ f.type }}:</strong> &nbsp; {{ f.values.join(' &nbsp; ') }}
    </div>
  </div>
</div>
